module.exports = __webpack_public_path__ + "img/footer5.445effcf.png";